import React, { Suspense, useCallback, useEffect } from "react";
import {
  HashRouter,
  Route,
  Switch,
  withRouter,
  Redirect,
  useHistory
} from "react-router-dom";
import { useWhichEnd } from '@mail/m-hooks';
import { TransitionGroup, CSSTransition } from "react-transition-group";
import ActivityBridge from "../utils/bridgeTool/ActivityBridge";
import LoginBridge from "../utils/bridgeTool/LoginBridge";
import routerConfig from "./config";
import config from "../utils/config";
import BaseTools from "../utils/bridgeTool/Base";

import { useStore } from "../stores";
import { getIfActivityExpired } from "../api";

import "./index.scss";

const Loading = () => {
  return (
    <div className="loading-wrapper">
      <img src={config.loadingUrl} />
      <div>加载中</div>
    </div>
  );
};

const PrivateRouter = (props: any) => {
  const [store] = useStore();
  return !!store.isLogin ? <props.component /> : <Redirect to={"/login"} />;
};

const Routes = withRouter(({ location }) => {
  const [store, dispatch] = useStore();
  const whitchEnd = useWhichEnd()
  const history = useHistory();

  const ifActivityExpired = useCallback(async () => {
    const { result }: any = await getIfActivityExpired();
    console.log(result)
    if (result?.code === 1005) {
      dispatch({
        type: 'changeState',
				payload: {
					isExpired: true
				}
      })
      history.replace({
        pathname: '/activityExpired'
      })
    } else {
      dispatch({
        type: 'changeState',
				payload: {
					isExpired: false
				}
      })
    }
  }, [history, dispatch])

  useEffect(() => {
    if (whitchEnd.pc) {
      return;
    }
    if (store.isExpired === undefined) {
      ifActivityExpired()
    } else if (store.isExpired) {
      history.replace({
        pathname: '/activityExpired'
      })
    }
  }, [history, ifActivityExpired, store.isExpired, whitchEnd.pc])

	useEffect(() => {
		if (whitchEnd.pc && window.location.hash.indexOf('diversion') === -1) {
      history.replace({
        pathname: '/diversion'
      })
		}
	})

  return (
    <Suspense fallback={<Loading />}>
      <Switch location={location}>
        {routerConfig.map((router) => {
          const { isPrivate, ...props } = router;
          return isPrivate ? (
            <PrivateRouter {...props} />
          ) : (
            <Route {...props} />
          );
        })}
      </Switch>
    </Suspense>
  )
});

export default function Router() {
  return (
    <HashRouter>
      <Routes />
    </HashRouter>
  );
}
